import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../../PulseSurvey/Topbar';
import EGiftCard from './EGiftCard';
import MarketplaceGourmetSociety from './MarketplaceGourmetSociety';

const TABS = [
  { id: 'e_gifts', label: 'E-gift cards' },
  { id: 'gormet-socity', label: 'Gourmet Society' }
];

const Marketplace = () => {
  const [activeTab, setActiveTab] = useState('e_gifts');

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketplace | Shoorah Admin</title>
      </Helmet>
      <Topbar title="Marketplace" infoBtn={false} />

      <div className="mt-6 flex flex-wrap gap-3">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`py-3 px-4 sm:w-44 w-[140px] rounded-3xl border-b-2 overflow-hidden dark:bg-shoorah-darkBgColor dark:text-white bg-white text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-500 dark:bg-shoorah-darkBgTabColor bg-blue-500/[.2]'
                : 'border-transparent text-gray-700 dark:text-gray-300 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'e_gifts' && <EGiftCard />}
      {activeTab === 'gormet-socity' && <MarketplaceGourmetSociety />}
    </div>
  );
};

export default Marketplace;
